"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PricelistController_js_1 = require("./PricelistController.js");
exports.PricelistController = PricelistController_js_1.PricelistController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/pricelists/controllers/index.js
// module id = 405
// module chunks = 0